import { render } from "./AccountUserEditPage.vue?vue&type=template&id=09d66410"
import script from "./AccountUserEditPage.vue?vue&type=script&lang=js"
export * from "./AccountUserEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__